import { Typography, Box, Button } from "@mui/material";

import { useNavigate } from "react-router-dom";
import color from "../../components/utils/Colors";

function QRCodeScanner() {
  const navigate = useNavigate();

  return (
    <Box sx={{ height:{xs:'70vh', md:'100vh'},mb:2,mt:1, display: "flex" }}>
      <Box
        sx={{
          display:{xs:'none', md:'flex'},
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          textAlign: "center",
          width: "50%",
          height: "100%",
          background: color.firstColor,
          backgroundImage: "url(/assets/backgroundsvg.svg)",
          backgroundRepeat: "repeat-y",
          backgroundSize: "100%",
          color: "white",

        }}
      >
         <Box
          onClick={() => {
            navigate("/");
          }}
          component="img"
          src="/assets/G2i-fav.svg"
          alt="Hero Image"
          sx={{
            position:'absolute',
            top:'12%',
            left:'2%',
            width: "50px",
            height: "auto",
            margin: "0 auto",
            mt: 2,
          }}
        />

        <Typography
          sx={{
            fontWeight: "bold",
            fontSize: "40px",
          }}
        >
          G2I
        </Typography>
        <Typography
          sx={{
            fontWeight: "bold",
            fontSize: "30px",
          }}
        >
          Global Genius Index (G2I)
        </Typography>
      </Box>

      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexDirection: "column",
          textAlign: "center",
          flexGrow: 1,
          py: 4,
          height: "100%",
          background: "white",
        }}
      >
        <Typography
          sx={{
            fontWeight: "bold",
            fontSize: "30px",
            color: color.textColor,
          }}
        >
          PAYMENT QR SCAN
        </Typography>

        <Box
          component="img"
          src="/assets/qr-code.svg"
          alt="Hero Image"
          sx={{
            width: "100%",
            height: "auto",
            maxWidth: "500px",
            margin: "0 auto",
            mt: 2,
          }}
        />

        <Button
          onClick={() => {
            navigate("/");
          }}
          id="button"
          style={{
            background: color.firstColor,
            color: "white",
            borderRadius: "8px",
            textTransform: "none",
            transition: "transform 0.3s ease",
          }}
          onMouseEnter={(e) => {
            const target = e.target as HTMLButtonElement;
            target.style.transform = "scale(1.05)";
          }}
          onMouseLeave={(e) => {
            const target = e.target as HTMLButtonElement;
            target.style.transform = "scale(1)";
          }}
        >
          Home
        </Button>
      </Box>
    </Box>
  );
}

export default QRCodeScanner;
